import React from 'react';
import moment from 'moment';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentsStore } from 'apps/experiments/src/store';
import styles from './_log-body.module.styl';
export function ExperimentLogBody() {
  var _resultsCache$message;
  const i18n = useTranslation();
  const experiment = useExperimentsStore(state => state.experiment);
  if (!experiment) {
    return null;
  }
  const resultsCache = experiment.results_cache;
  return <>
      <div className={styles.logBody}>{(_resultsCache$message = resultsCache.message) !== null && _resultsCache$message !== void 0 ? _resultsCache$message : ""}</div>
      <div className={styles.logUpdated}>
        {i18n.t("experiments.banner.message.updated", {
        updatedAt: moment(resultsCache.messageUpdatedAt).format("L"),
        updatedBy: resultsCache.messageUpdatedBy
      })}
      </div>
    </>;
}